import React from "react";
import { useSearchParams, Link } from "react-router-dom";

const PaymentResult = () => {
  const [params] = useSearchParams();

  const resultCode = params.get("resultCode") || "";
  const resultMsg  = params.get("resultMsg")  || "";
  const tid        = params.get("tid")        || "";
  const MOID       = params.get("MOID")       || "";
  const TotPrice   = params.get("TotPrice")   || "";
  const goodName   = params.get("goodName")   || "";
  const applDate   = params.get("applDate")   || "";
  const applTime   = params.get("applTime")   || "";

  const isSuccess = resultCode === "0000";

  return (
    <div className="container mt-5">
      <div className="card shadow-sm p-4" style={{ maxWidth: 600, margin: "0 auto" }}>
        <h4 className={`mb-4 ${isSuccess ? "text-success" : "text-danger"}`}>
          {isSuccess ? "✅ 결제 완료" : "❌ 결제 실패"}
        </h4>

        <table className="table table-bordered">
          <tbody>
            <tr><th>결과코드</th><td>{resultCode}</td></tr>
            <tr><th>결과메시지</th><td>{resultMsg}</td></tr>
            <tr><th>거래번호 (TID)</th><td>{tid || "-"}</td></tr>
            <tr><th>주문번호 (MOID)</th><td>{MOID || "-"}</td></tr>
            <tr><th>결제금액</th><td>{TotPrice ? `${Number(TotPrice).toLocaleString()}원` : "-"}</td></tr>
            <tr><th>상품명</th><td>{goodName || "-"}</td></tr>
            <tr><th>승인일자</th><td>{applDate || "-"}</td></tr>
            <tr><th>승인시간</th><td>{applTime || "-"}</td></tr>
          </tbody>
        </table>

        <Link to="/" className="btn btn-outline-primary mt-3">
          홈으로 돌아가기
        </Link>
      </div>
    </div>
  );
};

export default PaymentResult;